import { render, staticRenderFns } from "./UserBoardStep.vue?vue&type=template&id=ade3dfa0&scoped=true&"
import script from "./UserBoardStep.vue?vue&type=script&lang=js&"
export * from "./UserBoardStep.vue?vue&type=script&lang=js&"
import style0 from "./UserBoardStep.vue?vue&type=style&index=0&id=ade3dfa0&lang=scss&scoped=true&"
import style1 from "./UserBoardStep.vue?vue&type=style&index=1&id=ade3dfa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade3dfa0",
  null
  
)

export default component.exports